import { render } from "./PageAccessMenu.vue?vue&type=template&id=6bc9f42c"
import script from "./PageAccessMenu.vue?vue&type=script&lang=js"
export * from "./PageAccessMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__